import { ColorPalette, DarksPalette, FlowsPalette, isColorInPalette, LightsPalette } from "@tableau/tableau-ui";
import { Messages } from "../../../gen-src/Localize";

export enum ColorGridPreset {
  Dark,
  Light,
  MaestroFlowColors,
}

export const ColorPickerPresets: { [key in ColorGridPreset]: { palette: ColorPalette, label: () => string } } = {
  [ColorGridPreset.Dark]: { palette: DarksPalette, label: Messages.colorsDark },
  [ColorGridPreset.Light]: { palette: LightsPalette, label: Messages.colorsLight },
  [ColorGridPreset.MaestroFlowColors]: { palette: FlowsPalette, label: Messages.colorsFlow },
};
/**
 * @param color the hex value of the color to search for. Must be prefixed with a hash, e.g. `'#bfbfbf'`.
 * @param preset the palette to search.
 */
export function isColorInPreset(color: string, preset: ColorGridPreset): boolean {
  return isColorInPalette(color, ColorPickerPresets[preset].palette);
}
